// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.column-count-auto {
  column-count: auto !important;
}

@media (min-width: 768px) {
  .pl-md-3 {
    padding-left: 1rem;
  }
}
.dark-background {
  background-color: #414448;
  margin-bottom: -110px;
  margin-top: -150px;
  padding-bottom: 110px;
  padding-top: 150px;
}

.dark-background-overlay {
  z-index: 1;
}

.project-filter {
  margin-bottom: 20px;
  margin-top: 60px;
}

.main-header-menu {
  position: fixed;
  top: 45px;
  left: 67px;
  right: 0;
  padding-left: 15px;
  background-color: #efefef;
  z-index: 20;
}
.main-header-menu.coms-spacer {
  top: 39px;
}

@media (max-width: 1000px) {
  .main-header-menu {
    width: -moz-fit-content;
    width: fit-content;
  }
}
.sub-header-menu {
  position: fixed;
  top: 0;
  left: 68px;
  width: calc(100% - 66px);
  background-color: #efefef;
  height: 2.5rem;
  z-index: 10;
  padding-left: 15px;
}
.sub-header-menu.coms-spacer {
  top: 60px;
}

.heading {
  margin-top: calc(60px - 20px);
}

.search-bar-container {
  position: relative;
  top: 0.4rem;
}

.header-menu {
  position: relative;
  top: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/pages/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAgDA,sEAAA;AAYA,uBAAA;AC1DA;EACC,6BAAA;AACD;;AAGA;EACC;IACC,kBAAA;EAAA;AACF;AAGA;EACC,yBDKc;ECJd,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AADD;;AAIA;EACC,UAAA;AADD;;AAIA;EACC,mBAAA;EACA,gBAAA;AADD;;AAIA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,yBDNkB;ECOlB,WAAA;AADD;AAGC;EAGC,SAAA;AAHF;;AAOA;EACC;IACC,uBAAA;IAAA,kBAAA;EAJA;AACF;AAOA;EACC,eAAA;EACA,MAAA;EACA,UAAA;EACA,wBAAA;EACA,yBD3BkB;EC4BlB,cAAA;EACA,WAAA;EACA,kBAAA;AALD;AAOC;EACC,SDjBc;ACYhB;;AASA;EACC,6BAAA;AAND;;AASA;EACC,kBAAA;EACA,WAAA;AAND;;AASA;EACC,kBAAA;EACA,WAAA;AAND","sourcesContent":["// Core theme colors\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.column-count-auto {\n\tcolumn-count: auto !important;\n}\n\n// Used to keep the padding separation for success rate at desktop.\n@media (min-width: 768px) {\n\t.pl-md-3 {\n\t\tpadding-left: 1rem;\n\t}\n}\n\n.dark-background {\n\tbackground-color: $kaliber-dark;\n\tmargin-bottom: -110px;\n\tmargin-top: -150px;\n\tpadding-bottom: 110px;\n\tpadding-top: 150px;\n}\n\n.dark-background-overlay {\n\tz-index: 1;\n}\n\n.project-filter {\n\tmargin-bottom: 20px;\n\tmargin-top: 60px;\n}\n\n.main-header-menu {\n\tposition: fixed;\n\ttop: 45px;\n\tleft: 67px;\n\tright: 0;\n\tpadding-left: 15px;\n\tbackground-color: $background-light;\n\tz-index: 20;\n\n\t&.coms-spacer {\n\t\t// If this goes wrong, ensure that <body> is still position: relative\n\t\t// calc(#{$appComsHeight} + 45px) will work if it is not position: relative\n\t\ttop: 39px;\n\t}\n}\n\n@media (max-width: 1000px) {\n\t.main-header-menu {\n\t\twidth: fit-content;\n\t}\n}\n\n.sub-header-menu {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 68px;\n\twidth: calc(100% - 66px);\n\tbackground-color: $background-light;\n\theight: 2.5rem;\n\tz-index: 10;\n\tpadding-left: 15px;\n\n\t&.coms-spacer {\n\t\ttop: $appComsHeight;\n\t}\n}\n\n.heading {\n\tmargin-top: calc(#{$appComsHeight} - 20px);\n}\n\n.search-bar-container {\n\tposition: relative;\n\ttop: 0.4rem;\n}\n\n.header-menu {\n\tposition: relative;\n\ttop: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
